<div class="password-validity-container">
    <h4>Password Expiration Reminder</h4>
    <p >Your password is going to expire in <span>{{ daysLeft }}</span> days.</p>
    <div class="buttons">
      <button class="continue-button" (click)="onContinue()" [disabled]="isLoading">Continue</button>
      <button class="change-password-button" (click)="onChangePassword()">Change Password</button>
    </div>
  </div>